import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Controls, MatDialogCloseEvent, Mode } from '../../../const';
import { DtoSubCategory, DtoMetric, ModuleDetails, DtoModule, DtoPreviewItem, SubCategoryGrouping } from '../../../models/package-center.model';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { ProdetailsModalComponent } from '../prodetails-modal/prodetails-modal.component';
import { ModuleService } from './module.service';
import { Tabs } from '../data-management.component';
import { PackageService } from '../../package-center/package/package.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html'
})
export class ModuleComponent implements OnInit, OnChanges {
  @Output() setPageTitle = new EventEmitter<{}>();
  @Output() close = new EventEmitter<void>();
  @Input() showForm: boolean = false;
  @Input() isCurrentTab: string = "";
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";

  moduleControls = Controls;
  moduleForm: FormGroup = new FormGroup({
    moduleName: new FormControl([], [
      Validators.required
    ]),
    subCategories: new FormControl([], [
      Validators.required
    ]),
    metrics: new FormControl([], [
      Validators.required
    ]),
    sectorId: new FormControl(0, [
      Validators.required
    ]),
  });
  modules: ModuleDetails[] = [];
  subCategories: DtoSubCategory[] = [];
  subCategoryGroups: SubCategoryGrouping[] = [];

  subCategoriesForCreate: DtoSubCategory[] = [];
  metricsForCreate: DtoMetric[] = [];
  metrics: DtoMetric[] = [];
  isEdit: boolean = false;
  moduleToEdit: ModuleDetails = {} as ModuleDetails;
  tabs = Tabs;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  sortModuleNameAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";

  constructor(private packageService: PackageService,
    private toasterService: ToastrService,
    private dialog: MatDialog,
    private moduleService: ModuleService
  ) { }

  ngOnInit(): void {
    this.getAllModules();
    this.getSubCategoriesForModules();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['showForm']?.currentValue){
      this.moduleForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
    }
    if(this.searchTriggered){
      
      this.pageNumber = 0
      this.pageOffSet = 0;
      this.getAllModules();
    }
  }
  
  showCreateForm() {
    this.moduleForm.reset();
    this.showForm = true;
    this.isEdit = false;
    this.setPageTitle.emit(
      {
        tab: this.tabs.Module,
        mode: Mode.Create
      }
    );
  }

  closeCreateForm() {
    this.moduleForm.reset();
    this.showForm = false;
    this.close.emit();
    this.isEdit = false;
    this.subCategories = this.subCategoriesForCreate;
    this.metrics = this.metricsForCreate;
  }

  getAllModules(sortColumn = "", sortDirection = "") {
    let sectorId = Number(sessionStorage.getItem('sector'));
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
      
    this.moduleService.getAllModules(sectorId, payload).subscribe((response: ModuleDetails[] | any) => {
      this.modules = response;
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.moduleForm.reset();
      this.isEdit = false;
      this.showForm = false;
      this.close.emit();
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getAllModules();
  }
  

  getGroupings():SubCategoryGrouping[]{
    const groupMap = new Map<string, SubCategoryGrouping>();
    const result: SubCategoryGrouping[] = [];
    var input = this.subCategories;
    for (const item of input) {
      if (item.subCategoryDisplayName === null) {
        // Push ungrouped items directly
        result.push({
          groupName: null,
          isExpanded:false,
          items:[item]
        } as SubCategoryGrouping);
      } else {
        // Group by groupName
        if (!groupMap.has(item.subCategoryDisplayName)) {
          var newGroup = {
            groupName: item.subCategoryDisplayName,
            isExpanded:(result.length==0),
            items: []
          } as SubCategoryGrouping;
          groupMap.set(item.subCategoryDisplayName, newGroup);
          result.push(newGroup);
        }
        groupMap.get(item.subCategoryDisplayName)!.items.push(item);
      }
    }

    return result;
  }

  getSubCategoriesForModules() {
    let sectorId = Number(sessionStorage.getItem('sector'));
    this.moduleService.getSubCategoriesForModules(sectorId, {} as DtoModule).subscribe((response: DtoSubCategory[] | any) => {
      this.subCategoriesForCreate = response;
      this.subCategories = response;
      this.subCategoryGroups = this.getGroupings();
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  onSubCategoryChange(selectedSubCategory: any) {
    let payload = selectedSubCategory.value;
    this.packageService.getMetrics(payload).subscribe((response: DtoMetric[] | any) => {
      this.metrics = response;
      this.metricsForCreate = this.metrics;
      this.moduleForm.controls['metrics'].setValue(this.metrics);
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  checkIfDataExists(field: string) {
    if (field == this.moduleControls.SubCategory) {
      if (!this.subCategories.length) {
        this.toasterService.warning("No new Analytics Toolkits are available. Please create an Analytics Toolkit to proceed!")
      }
    }
    if (field == this.moduleControls.Metrics) {
      if (!this.metrics.length) {
        this.toasterService.warning("No new metric is available. Please create a metric to proceed!")
      }
    }
  }

  removeSubCategory(SubCategoryToRemove: DtoSubCategory) {
    this.moduleForm.controls['subCategories'].setValue(this.moduleForm.controls['subCategories'].value.filter((x: DtoSubCategory) => x.subCategoryId != SubCategoryToRemove.subCategoryId));
    this.onSubCategoryChange({ value: this.moduleForm.controls['subCategories'].value });
  }

  removeMetric(metricToRemove: DtoMetric) {
    if (this.isEdit) {
      this.toasterService.warning("The metric cannot be deleted!");
      return
    }
    return this.moduleForm.controls['metrics'].setValue(this.moduleForm.controls['metrics'].value.filter((x: DtoMetric) => x.metricId != metricToRemove.metricId))
  }

  createModule() {
    let payload: ModuleDetails = JSON.parse(JSON.stringify(this.moduleForm.value))
    if (this.isEdit) {
      payload.moduleId = this.moduleToEdit.moduleId;
      this.moduleService.updateModule(payload).subscribe((res => {
        this.toasterService.success("Module updated successfully", "Success");
        this.getAllModules();
      }), (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      })
      return;
    }
    this.moduleService.createModule(payload).subscribe(response => {
      if (response) {
        this.toasterService.success("Module created successfully", "Success");
        this.getAllModules();
      }
    }, (error: HttpErrorResponse) => {
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  editModule(moduleDetail: ModuleDetails) {
    this.moduleForm.controls['sectorId'].setValue(Number(sessionStorage.getItem('sector')));
    this.setPageTitle.emit({
      tab: this.tabs.Module,
      mode: Mode.Edit
    });
    this.isEdit = true;
    this.showForm = true;
    this.moduleToEdit = moduleDetail;
    let sectorId = Number(sessionStorage.getItem('sector'));

    const module: DtoModule = {
      moduleId: moduleDetail.moduleId,
      moduleName: moduleDetail.moduleName
    };

    this.moduleService.getSubCategoriesForModules(sectorId, module).subscribe((subCategories: DtoSubCategory[] | any) => {
      this.subCategories = subCategories;
      this.subCategoryGroups = this.getGroupings();
      this.packageService.getMetrics(moduleDetail.subCategories).subscribe((metrics: DtoMetric[] | any) => {
        this.metrics = metrics;

        const subCategoryList = this.subCategories.filter(subCategory =>
          moduleDetail.subCategories.some(pkgSubCategory => subCategory.subCategoryId === pkgSubCategory.subCategoryId)
        );
        const metricsList = this.metrics.filter(metric =>
          moduleDetail.metrics.some(pkgMetric => metric.metricId === pkgMetric.metricId)
        );

        this.moduleForm.patchValue({
          moduleName: moduleDetail.moduleName,
          subCategories: subCategoryList,
          metrics: metricsList
        });
      });
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  deleteModule(moduleDetail: ModuleDetails) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the module?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.moduleService.deleteModule(moduleDetail.moduleId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Module deleted successfully!", "Success");
            this.getAllModules();
          }
        }, (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    });
  }

  getPreviewData(control: string, moduleDetails: ModuleDetails = {} as ModuleDetails):DtoPreviewItem[] {
    switch (control) {
      case this.moduleControls.SubCategory:
        if (moduleDetails.moduleId) {
          return this.modules.find((x: ModuleDetails) => x.moduleId == moduleDetails.moduleId)?.subCategories?.map((x: DtoSubCategory) => ({
            groupName: x.moduleDisplayName,
            itemDisplay: x.subCategoryDisplayName,
            itemName: x.subCategoryName
          })) as DtoPreviewItem[];
        }
        else {
          return this.moduleForm.controls['subCategories'].value.map((x: DtoSubCategory) => ({
            groupName: x.moduleDisplayName,
            itemDisplay: x.subCategoryDisplayName,
            itemName: x.subCategoryName} as DtoPreviewItem))  as DtoPreviewItem[];
        }
      case this.moduleControls.Metrics:
        if (moduleDetails.moduleId) {
          return this.modules.find((x: ModuleDetails) => x.moduleId == moduleDetails.moduleId)?.metrics?.map((x: DtoMetric) =>({ 
            groupName:null,
            itemName: x.metricName}))   as DtoPreviewItem[];
        }
        else {
          return this.moduleForm.controls['metrics'].value.map((x: DtoMetric) => ({
            groupName:null,
            itemName: x.metricName}))   as DtoPreviewItem[];
        }
      default:
        return [];
    }
  }

  previewPopup(control: string, moduleDetails: ModuleDetails = {} as ModuleDetails) {
    this.dialog.open(ProdetailsModalComponent, {
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: true,
        itemToPreview: this.getPreviewData(control, moduleDetails),
        title: control == this.moduleControls.Metrics ? 'Added Metrics' : 'Added Analytics Toolkits'
      }
    })
  }

  activateDeactivateModule(moduleDetail: ModuleDetails) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: moduleDetail.status,
        message: "Are you sure want to" + (moduleDetail.status ? " inactivate" : " activate") + " the module?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.moduleService.updateModuleStatus(moduleDetail.moduleId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Module" + (moduleDetail.status ? " activated" : " inactivated") + " successfully", "Success");
            this.getAllModules();
          }
        }, (error: HttpErrorResponse) => {
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
          moduleDetail.status = !moduleDetail.status;
        })
      }
      else {
        moduleDetail.status = !moduleDetail.status
      }
    });
  }
}
